import { render, staticRenderFns } from "./TableNotifications.vue?vue&type=template&id=5aecc017&scoped=true&"
import script from "./TableNotifications.vue?vue&type=script&lang=js&"
export * from "./TableNotifications.vue?vue&type=script&lang=js&"
import style0 from "./TableNotifications.vue?vue&type=style&index=0&id=5aecc017&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aecc017",
  null
  
)

export default component.exports